import 'moment/locale/ja'

import React from 'react'

import AuthProvider from '@/contexts/Auth.context'
import LanguageContextProvider from '@/contexts/Language'
import Routes from '@/routes'

import NotificationContextProvider from './contexts/Notification.context'
import GlobalStyle from './GlobalStyle'

function App() {
  return (
    <AuthProvider>
      <GlobalStyle />
      <LanguageContextProvider>
        <NotificationContextProvider>
          <Routes />
        </NotificationContextProvider>
      </LanguageContextProvider>
    </AuthProvider>
  )
}

App.displayName = 'App'
export default App
